import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["generateButton", "documentsIds", "form"]
  static values = {
    selectedDocuments: {
      type: Array,
      default: []
    },
    isInstructionFilled: Boolean
  }

  fillInstruction(event) {
    this.isInstructionFilledValue = event.currentTarget.value !== ""
  }

  fillSelectedDocuments(event) {
    this.selectedDocumentsValue = event.detail.selectedRows
  }

  selectedDocumentsValueChanged() {
    this.#enableSubmit()
    this.#updateDocumentsIds()
  }

  isInstructionFilledValueChanged() {
    this.#enableSubmit()
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  #enableSubmit() {
    this.generateButtonTarget.disabled = !this.isInstructionFilledValue || this.selectedDocumentsValue.length === 0
  }

  #updateDocumentsIds() {
    this.documentsIdsTarget.innerHTML = ""
    this.selectedDocumentsValue.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "report[documents_ids][]"
      input.value = id
      this.documentsIdsTarget.appendChild(input)
    })
  }
}
